import { IndeterminateCircleLoader, PROGRESS_CIRCLE_SIZE } from "@cdkglobal/radial";
import { LoaderContainer } from "../../utils/styled";

type ProgressCircleSize = typeof PROGRESS_CIRCLE_SIZE[keyof typeof PROGRESS_CIRCLE_SIZE];

interface LoaderProps {
  /** Aria label for accessibility (default: "") */
  ariaLabel?: string;
  /** Hide the label text (default: true) */
  hideLabel?: boolean;
  /** Inline layout mode (default: false) */
  isInline?: boolean;
  /**
   * Loader size preset:
   * - PROGRESS_CIRCLE_SIZE.SMALL (20px) - for inputs, buttons, chips
   * - PROGRESS_CIRCLE_SIZE.LARGE (48px) - default, for dropdowns
   * - PROGRESS_CIRCLE_SIZE.EXTRA_LARGE (64px) - large screen portions
   * - PROGRESS_CIRCLE_SIZE.XXL (96px) - full screen loader
   */
  size?: ProgressCircleSize;
}

const Loader = ({
  ariaLabel = "",
  hideLabel = true,
  isInline = false,
  size = PROGRESS_CIRCLE_SIZE.LARGE,
}: LoaderProps) => (
  <LoaderContainer>
    <IndeterminateCircleLoader
      ariaLabel={ariaLabel}
      size={size}
      isInline={isInline}
      hideLabel={hideLabel}
    />
  </LoaderContainer>
);

export default Loader;
